import { ComboBox, keyframes, SelectableOptionMenuItemType } from '@fluentui/react';
import { concatStyleSets } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import { Immocom } from '../../specifique/immocom';

export class EUIComboBox extends Component {

    // KP - 09/05/2023 : keyAsString remplacé par idValeurParDefaut (plus souple à l'utilisation)
    // Dans la majorité des cas cet id est égal à 0, mais dans certaines ComboBox cet id est égal à "0"
    // Dans la ComboBoxRegionAdministrative il est égal à null (car l'id 0 est utilisé en BDD)

    static defaultProps = {
        autoComplete: "on",
        avecValeurDefaut: true,
        disabled: false,
        extractItems: (reponseAPIobjet) => reponseAPIobjet || [], // Méthode utilisé pour extraire les items du reponseAPIobjet
        fetchMethod: undefined,
        groupBy: undefined,
        idValeurParDefaut: 0,
        itemData: (item) => null, // Méthode utilisée pour inclure à chaque option des data supplémentaires
        itemDisabled: (item) => false, // Détermine si l'option est grisée ou non
        itemHidden: (item) => false, // Détermine si l'option est masquée ou non
        itemKey: (item) => item.key, // Méthode utilisée pour construire la key de chaque item
        itemText: (item) => item.text, // Méthode utilisée pour construire le texte de chaque item
        //keyAsString: false,
        label: "",
        multiSelect: false,
        onChange: (event, option, index, value, item) => null,
        onLoad: undefined, // (selectedItem, items) => Méthode appelée au chargement de la ComboBox si selectedKey est déjà connue, utilisé notamment pour récupérer des informations de l'item associé à selectedKey
        options: undefined, // Si options est renseigné, fetchMethod n'est pas appelé
        placeholder: undefined,
        selectedKey: null,
        selectedKeysOnTop: false,
        stamp: undefined, // Lorsqu'il est modifié, le stamp déclenche un nouveau chargement des données (via fetchMethod)
        styles: {},
        top: undefined, // Si renseigné n'affiche que les n premiers éléments de la liste
    };

    constructor(props) {
        super(props);
        this.items = [];
        this.state = {
            loading: false,
            options: []
        };
    };

    _chargementDonnees = () => {

        const { allowFreeform, avecValeurDefaut, extractItems, fetchMethod, groupBy, idValeurParDefaut, multiSelect, options, top } = this.props;

        // Si props.options existent alors elles bypass fetchMethod
        if (!!options && Array.isArray(options)) {
            let newOptions = [];
            if (avecValeurDefaut && !multiSelect) {
                const text = allowFreeform ? "Sélectionnez ou saisissez" : null;
                Immocom.ajoutValeurDefautDansOption(this, newOptions, idValeurParDefaut, text);
            }
            newOptions.push(...options);

            if (!!top) {
                const offset = avecValeurDefaut ? 1 : 0;
                options = options.slice(0, top + offset);
            }

            this.setState({ options: newOptions });
        }

        else if (!!fetchMethod && typeof fetchMethod === "function") {

            const { itemData, itemDisabled, itemHidden, itemKey, itemText } = this.props;
            this.setState({ loading: true });

            fetchMethod().then(responseFetch => {

                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {

                    this.items = extractItems(responseFetch.reponseAPIobjet)
                    let options = [];

                    if (avecValeurDefaut && !multiSelect) {
                        const text = allowFreeform ? "Sélectionnez ou saisissez" : null;
                        Immocom.ajoutValeurDefautDansOption(this, options, idValeurParDefaut, text);
                    }

                    // Si groupBy existe, trier les items selon groupBy, et gérer l'insertion des dividers et headers
                    let category;
                    if (!!groupBy) this.items.sort((a, b) => a[groupBy] - b[groupBy]);

                    this.items.map((item, index) => {

                        if (!!groupBy) {
                            // Insertion d'un divider et d'un header
                            if (category !== item[groupBy]) {
                                if (!!category) options.push({ key: `divider-${index}`, text: "-", itemType: SelectableOptionMenuItemType.Divider });
                                options.push({ key: item[groupBy], text: item[groupBy] || "Indéfini", itemType: SelectableOptionMenuItemType.Header });
                                category = item[groupBy];
                            }
                        }

                        const hidden = !!itemHidden && typeof itemHidden === "function" && itemHidden(item);
                        if (!hidden) {
                            let option = { key: itemKey(item), text: itemText(item) };
                            if (!!itemData && typeof itemData === "function") option.data = itemData(item);
                            if (!!itemDisabled && typeof itemDisabled === "function") option.disabled = itemDisabled(item);
                            options.push(option);
                        }

                    });

                    if (!!top) {
                        const offset = avecValeurDefaut ? 1 : 0;
                        options = options.slice(0, top + offset);
                    }

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, { loading: false, options }, this._onLoad);

                } else Immocom.onTraitementErreurAvecState(this, { loading: false, options: [] }, retourVerif, responseFetch);
            });

        }

    };

    _onChange = (event, option, index, value) => {
        const { allowFreeform, itemKey, onChange } = this.props;
        if (allowFreeform && !option) { // Si saisie personnalisée autorisée et si saisie personnalisée effectuée
            const newOption = { // Alors créer et ajouter une nouvelle option à la ComboBox
                key: Date.now() & 0xffffffff, // Id unique ; & 0xffffffff assure une compatibilité Int32
                text: value
            };
            this.setState(
                prevState => ({ options: [...prevState.options, newOption] }),
                () => onChange(event, newOption, index, value, {})
            );
        }
        else {
            const item = this.items.find(item => itemKey(item) === option.key) || {};
            onChange(event, option, index, value, item);
        }
    };

    _onLoad = () => {
        const { itemKey, multiSelect, onLoad, selectedKey, selectedKeysOnTop } = this.props;
        const callback = (item) => {
            if (!!onLoad && typeof onLoad === "function")
                onLoad(item, this.items);
        };

        // Si aucune option sélectionnée, alors exécuter uniquement le prop.onLoad (pour récupérer la liste des items par exemple)
        if (!multiSelect && !selectedKey) callback({});
        else if (multiSelect && !!selectedKey && Array.isArray(selectedKey) && selectedKey.length === 0) callback({});

        if (!!selectedKey && !multiSelect) {
            let options = [...this.state.options];
            const option = options.find(option => option.key === selectedKey);

            // Si selectedKey n'appartient pas à la liste déroulante, alors on l'ajoute mais on bloque la sélection
            // Fonctionnalité demandée par Eiffage : permet une souplesse sur les data envoyées aux API par les partenaires
            // Exemple : FicheContact, la civilité n'est parfois pas renseignée ; du coup pour modifier un contact, l'utilisateur est obligé de mettre à jour la civilité
            if (!option) {
                options.push({ key: selectedKey, text: selectedKey, disabled: true });
                this.setState({ options }, callback({}))
            } else {
                const item = this.items.find(item => itemKey(item) === selectedKey);
                callback(item);
            }
        }

        if (multiSelect && selectedKeysOnTop && !!selectedKey && Array.isArray(selectedKey) && selectedKey.length > 0)
            this._putSelectedKeysOnTop();
    };

    _putSelectedKeysOnTop = () => {
        const { selectedKey } = this.props;
        const { options } = this.state;
        let newOptions = selectedKey.map(key => { // Options sélectionnées d'abord, dans l'ordre de la sélection
            const option = options.find(option => option.key === key);
            return {
                ...option,
                text: option.text + "\u200b" // Force si besoin le onRenderOption des options sélectionnées
            };
        });
        newOptions.push(...options.filter(option => selectedKey.indexOf(option.key) < 0)); // Options restantes
        this.setState({ options: newOptions });
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };

    componentDidUpdate = (prevProps) => {
        const { multiSelect, options, selectedKey, selectedKeysOnTop, stamp } = this.props;

        if (JSON.stringify(prevProps.stamp) !== JSON.stringify(stamp))
            this.setState({ options: [] }, this._chargementDonnees);

        else if (!prevProps.selectedKey && !!selectedKey) {
            if (this.items.length > 0)
                this._onLoad();
        }

        else if (multiSelect && selectedKeysOnTop && prevProps.selectedKey.join(";") != selectedKey.join(";")) // La sélection multiple a changé
            this._putSelectedKeysOnTop();

        else if (JSON.stringify(prevProps.options) !== JSON.stringify(options))
            this._chargementDonnees();
    };

    render = () => {

        const { avecValeurDefaut, disabled, idValeurParDefaut, itemKey, itemText, multiSelect, placeholder, selectedKey, styles } = this.props;
        const { loading, options } = this.state;

        // Si props.selectedKey falsy alors afficher la valeur par défaut
        let key = selectedKey;
        if (!key) {
            if (multiSelect) key = [];
            else {
                // A moins que cette falsy value soit aussi associée à une option
                const optionExists = options.some(option => option.key === key);
                if (!optionExists && avecValeurDefaut)
                    key = idValeurParDefaut;
            }
        }

        // Si sélection multiple, conditionner la valeur du texte affiché dans la ComboBox en fonction du nombre d'options sélectionnées
        let text = undefined;
        let stylesAdditionnels = undefined;
        if (multiSelect) {
            if (selectedKey.length === 0 && avecValeurDefaut)
                text = "Sélectionnez";
            else if (selectedKey.length === 1) {
                const item = this.items.find(item => itemKey(item) === selectedKey[0]);
                if (!!item) text = itemText(item);
            }
            else if (selectedKey.length >= 2)
                text = `${selectedKey.length} options sélectionnées`;
        }
        // Si pas de sélection multiple + aucune option sélectionnée + pas de valeur par défaut alors simuler un placeholder
        // Car OUIF ne permet pas de rafficher le placeholder si une option a été sélectionnée
        else if (!selectedKey && !avecValeurDefaut) {
            text = placeholder || " ";
            stylesAdditionnels = {
                input: {
                    color: "rgb(199, 199, 199)",
                    selectors: { "&:hover": { color: "rgb(133, 133, 133) !important" } }
                }
            };
        }

        let iconButtonProps = {};
        if (loading) iconButtonProps = { iconProps: { iconName: "Refresh" } };

        let caretDownButtonStyles = {};
        if (loading) caretDownButtonStyles = {
            icon: {
                animationDuration: "3s",
                animationIterationCount: "infinite",
                animationName: keyframes({
                    "0%": { transform: "rotate(0deg)" },
                    "100%": { transform: "rotate(360deg)" },
                })
            }
        };

        return <ComboBox
            {...this.props}
            caretDownButtonStyles={caretDownButtonStyles}
            disabled={disabled || !options.length}
            iconButtonProps={iconButtonProps}
            onChange={this._onChange}
            options={options}
            selectedKey={key}
            styles={concatStyleSets(styles, { label: { fontWeight: "unset" } }, stylesAdditionnels)} // fontWeight unset pour conserver l'ancien visuel d'OUIF
            text={text}
        />;

    };

};